<template>
  <!-- BEGIN: Mobile Menu -->
  <div class="mobile-menu xl:hidden">
    <div class="mobile-menu-bar">
      <a :href="homepage" class="flex mr-auto">
        <img
          alt="Corruption Cases Database Logo"
          class="w-12"
          src="@/assets/images/logo.png"
        />
      </a>
      <!-- <BarChart2Icon
        class="w-8 h-8 text-white transform -rotate-90"
        @click="toggleMobileMenu"
      /> -->
      <HamburgerIcon
        class="z-20 cursor-pointer w-8 h-8 text-white"
        :status="isNavOpen"
        @click.native="toggleMobileMenu"
        @setNav="isNavOpen = !isNavOpen"
      />
    </div>
    <transition @enter="enter" @leave="leave">
      <ul v-if="activeMobileMenu" class="border-t border-theme-24 py-5">
        <!-- BEGIN: First Child -->
        <template v-for="(menu, menuKey) in formattedMenu">
          <li
            v-if="menu == 'devider'"
            :key="menuKey"
            class="menu__devider my-6"
          ></li>
          <li v-else :key="menuKey">
            <a
              href="javascript:;"
              class="menu"
              :class="{
                'menu--active': menu.active,
                'menu--open': menu.activeDropdown
              }"
              @click="linkTo(menu)"
            >
              <div class="menu__icon">
                <component :is="menu.icon" />
              </div>
              <div class="menu__title">
                {{ menu.title }}
                <ChevronDownIcon
                  v-if="$h.isset(menu.subMenu)"
                  class="menu__sub-icon"
                  :class="{ 'transform rotate-180': menu.activeDropdown }"
                />
              </div>
            </a>
            <!-- BEGIN: Filter Menu -->
            <template v-for="(filter, filterKey) in filterMenu">
              <!-- <li
                v-if="menu == 'devider'"
                :key="menuKey"
                class="side-nav__devider my-6"
              ></li> -->
              <li
                :key="'filter' + filterKey"
                class="text-white px-4 sm:px-10 my-4"
              >
                <SideMenuTooltip
                  tag="span"
                  :content="filter.title"
                  class="side-menu"
                >
                  <div class="menu__icon">
                    <component :is="filter.icon" />
                  </div>
                  <div class="menu__title">
                    {{ filter.title }}
                  </div>
                </SideMenuTooltip>
                <!-- BEGIN: Second Child -->
                <transition @enter="enter" @leave="leave">
                  <tags-input
                    v-model="filter_params[filter.model]"
                    :element-id="filter.title"
                    :add-tags-on-comma="true"
                    :typeahead="true"
                    :typeahead-url="api_url + filter.endpoint"
                    :typeahead-show-on-focus="true"
                    :typeahead-activation-threshold="0"
                    :typeahead-max-results="0"
                    :only-existing-tags="true"
                    typeahead-style="dropdown"
                  ></tags-input>
                </transition>
                <!-- END: Second Child -->
              </li>
            </template>
            <!-- END: Filter Menu  -->
          </li>
        </template>
        <!-- END: First Child -->
        <div class="flex justify-content-center px-4 sm:px-10">
          <button
            v-if="filterMenu.length > 0"
            class="w-full bg-white my-8 p-4 rounded-lg text-transpurple text-xl"
            @click="filterPortal"
          >
            FILTER
          </button>
        </div>
      </ul>
    </transition>
  </div>
  <!-- END: Mobile Menu -->
</template>

<script>
import Velocity from "velocity-animate";
import VoerroTagsInput from "@voerro/vue-tagsinput";
import { createNamespacedHelpers } from "vuex";
import HamburgerIcon from "@/components/HamburgerIcon";

const { mapActions } = createNamespacedHelpers("filtersMenu");

export default {
  components: {
    "tags-input": VoerroTagsInput,
    HamburgerIcon
  },
  data() {
    return {
      formattedMenu: [],
      filterMenu: this.$store.state.filtersMenu.filters,
      activeMobileMenu: false,
      api_url: `${window.api}`,
      filter_params: {},
      url_params: {},
      host_url: `${window.host}`,
      homepage: `${window.homepage}`,
      isNavOpen: false
    };
  },
  computed: {
    mobileMenu() {
      return this.nestedMenu(this.$store.state.sideMenu.menu);
    }
  },
  watch: {
    $route() {
      this.formattedMenu = this.$h.assign(this.mobileMenu);
    }
  },
  mounted() {
    this.formattedMenu = this.$h.assign(this.mobileMenu);
  },
  methods: {
    ...mapActions(["changeSelectedFilters"]),
    filterPortal() {
      for (let filter in this.filter_params) {
        let arr = [];
        this.filter_params[filter].forEach(item => {
          arr.push(item["key"]);
        });
        this.url_params[filter] = arr;
      }
      // this.$store.dispatch(
      //   "filtersMenu/changeSelectedFilters",
      //   this.url_params
      // );
      this.changeSelectedFilters(this.url_params);
    },
    toggleMobileMenu() {
      this.activeMobileMenu = !this.activeMobileMenu;
    },
    nestedMenu(menu) {
      menu.forEach((item, key) => {
        if (typeof item !== "string") {
          menu[key].active =
            (item.pageName == this.$route.name ||
              (this.$h.isset(item.subMenu) &&
                this.findActiveMenu(item.subMenu))) &&
            !item.ignore;
        }

        if (this.$h.isset(item.subMenu)) {
          menu[key].activeDropdown = this.findActiveMenu(item.subMenu);
          menu[key] = {
            ...item,
            ...this.nestedMenu(item.subMenu)
          };
        }
      });

      return menu;
    },
    findActiveMenu(subMenu) {
      let match = false;
      subMenu.forEach(item => {
        if (item.pageName == this.$route.name && !item.ignore) {
          match = true;
        } else if (this.$h.isset(item.subMenu)) {
          match = this.findActiveMenu(item.subMenu);
        }
      });
      return match;
    },
    linkTo(menu) {
      if (this.$h.isset(menu.subMenu)) {
        menu.activeDropdown = !menu.activeDropdown;
      } else {
        this.activeMobileMenu = false;
        this.$router.push({
          name: menu.pageName
        });
      }
    },
    enter(el, done) {
      Velocity(
        el,
        "slideDown",
        {
          duration: 300
        },
        {
          complete: done
        }
      );
    },
    leave(el, done) {
      Velocity(
        el,
        "slideUp",
        {
          duration: 300
        },
        {
          complete: done
        }
      );
    }
  }
};
</script>
